<script setup lang="ts">
import type { SortingDirection } from '@/modules/Workspaces/KnowledgeHub/Files/library-item'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'

defineProps<{
  /**
   * Sorting direction for this column
   * Undefined means that the column is not sortable
   * Null means that the column is sortable, but table is sorting on a different column
   */
  sort?: SortingDirection | null
}>()
defineEmits<{ toggle: [] }>()
</script>

<template>
  <span
    v-if="sort === undefined"
    class="flex items-center gap-1 text-xs-11px-default text-text-subtlest"
  >
    <slot />
  </span>
  <DarwinButton
    v-else
    size="xs"
    variant="transparent"
    rounded
    class="-ml-2"
    @click="$emit('toggle')"
  >
    <!-- 👆 Negative margin so that text aligns with text in content cells below -->
    <span
      class="flex items-center gap-1 text-xs-11px-default"
      :class="[sort ? '' : 'text-text-subtlest']"
    >
      <slot />
      <IconSprite
        v-if="sort"
        :icon="sort === 'desc' ? 'arrow-bottom' : 'arrow-top'"
        size="xs"
      />
    </span>
  </DarwinButton>
</template>
